import { type FC } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { ConversationsFilter } from "./ConversationsFilter";
import { ConversationsList } from "./ConversationsList";
import { ConversationDialog } from "./ConversationDialog";

// Открытие карточки через ?id= (не ?tab=...&id=, как у Products): ссылка из
// письма обращения ведёт на .../conversations?id=<id> и должна сразу
// открывать диалог без дополнительного параметра.
export const Conversations: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id");

  const handleOpen = (conversationId: string) => {
    searchParams.set("id", conversationId);
    setSearchParams(searchParams);
  };

  const handleClose = () => {
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <ConversationsFilter />
        <ConversationsList onOpenConversation={handleOpen} />
      </Stack>

      <ConversationDialog
        open={Boolean(id)}
        conversationId={id}
        onClose={handleClose}
      />
    </FilterProvider>
  );
};
